import {get, post} from '~/utils/request';

export function getList(data) {
  return post('/Interview/AllChInterview', data);
}

export function basicInfo(data) {
  return post('/Interview/InterviewInfo', data);
}

export function basicInfoByNo(data) {
  return post('/Interview/InterviewInfoByNo', data);
}

export function lastInterviewInfo(data) {
  return post('/Interview/GetLoInterviewByID', data);
}

export function roundList(data) {
  return post('/Interview/InterviewRoundList', data);
}

export function interviewResultList() {
  return get('/Interview/GetInterviewResultList');
}

export function setInterviewResult(data) {
  return post('/Interview/SetInterviewResult', data);
}

export function createReinterview(data) {
  return post('/Interview/DealCallback', data);
}

export function hrCancelReasonList(data) {
  return get('/Interview/GetHrCancelReasonList');
}

export function cancelInterview(data) {
  return post('/Interview/Cancel', data);
}